<h3 class="mb-2">{{title}}</h3>
<app-account-items-vouchers [vouchers]="vouchers" (itemSelected)="useItem($event)"></app-account-items-vouchers>

<h3 class="m-0 mt-5 mb-2">{{'gift-card.title' | translate}}</h3>
<app-account-items-cards [cards]="giftCards" (itemSelected)="useItem($event)"></app-account-items-cards>